import ApiGateway from '../aws/api-gateway/ApiGateway';
const debug = process.env.REACT_APP_DEBUG && false;
const apiRef = 'SystemManagementApi';
const assignGatewayToCustomer = async ({ gateway, contextCustomer, assignmentCustomer, contextUser, assignmentCustomerGroup, }) => {
    let response = { err: null, data: null };
    response = await ApiGateway.post('/system/Gateway/assignGatewayToCustoemr', { contextUser, gateway, contextCustomer, assignmentCustomer, assignmentCustomerGroup }, apiRef);
    debug && console.log('Add response', response);
    return response;
};
export const deleteGateway = async ({ contextCustomer, contextUser, gateway }) => {
    let response = { err: null, data: null };
    const params = {
        contextCustomer,
        contextUser,
        gateway,
    };
    response = await ApiGateway.post('/system/Gateway/deleteGateway', params, apiRef);
    debug && console.log('Add response', response);
    return response;
};
/**
 * **Gateway DAO**
 */
export const GatewayDAO = {
    assignGatewayToCustomer,
    deleteGateway,
};
